import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Field } from 'redux-form';
import {Link} from 'react-router-dom';

import Form from 'common/components/Form';
import Button from 'common/components/Button/Button';
import Input from 'common/components/Input/Input';

import './ForgotForm.less';

import validate from './validate';
import { Urls } from 'django_js_control/reverse';

class ForgotForm extends Component {

    render() {

        const {
            email,
            status,
            onSubmit,
            loginPending
        } = this.props;

        return (
            <Form className="LoginContainer-form"
                  form="forgot"
                  validate={validate}
                  onSubmit={onSubmit}>

                {!status &&
                    <div className="LoginContainer-message">
                        Please enter your e-mail and we will send you a link where you will be able to set a new password.
                    </div>
                }

                {status && status === 'sent' &&
                    <div className="LoginContainer-message">
                        E-mail has been sent to {email}!
                    </div>
                }

                {!status &&
                    <div>
                        <Field component={Input}
                               label="E-mail"
                               name="email"
                               grow={true}/>

                        <div className="LoginContainer-button">
                            <Button type="solid"
                                    color="primary"
                                    disabled={loginPending}
                                    grow={true}>
                                Send
                            </Button>
                        </div>
                    </div>
                }
                <div className="LoginContainer-linkContainer">
                    <Link className="LoginContainer-link" to={Urls['control:login:login']()}>Go back</Link>
                </div>
            </Form>
        );
    }
}

export default ForgotForm;



// WEBPACK FOOTER //
// ./assets/app/login/components/ForgotForm/ForgotForm.jsx